export const INFO_STATEMENTS = {
    ACCOUNT_CREATED: 'Account created successfully! Please check email and activate your account.',
    SUCCESS: "success",
    FAILED: "failed",
    DANGER: 'danger',
    PASSWORD_RESET_SENT: 'Password reset link has been sent to your email address.',
    PASSWORD_RESET_SUCCESSFUL: 'Password reset successful! You can now login with your new password.'
};

export const COMPLETED = 'completed'
export const FAILED = 'failed'
export const PENDING = 'pending'
export const PROCESSING = 'processing'

export const ERROR_MESSAGES = {
    PASSWORD_MISSMATCH: 'Passwords do not match',
    PASSWORD_LENGTH_ERROR: 'Password must be at least 8 characters long',
    ERROR_RESPONSE: 'An error occurred. Please try again.',
    NETWORK_ERROR: 'Network error. Please check your connection and try again.',
    INVALID_INPUT: 'Invalid input',
    MISSING_USER_ID: "No user ID found in local storage.",
    ERROR: 'Error! ',
    ERROR_SHARED_DATA: "Error fetching shared data:",
    FAILED_NOTIFICATION: "Failed to fetch notifications",
    PASSWORD_RESET_FAILED: 'Password reset request failed, please try again',
    INVALID_RESET_LINK: 'Invalid reset link. Please request a new password reset.',
}

export const SYSTEM_DEFAULTS = {
    PAGE_SIZE: 20,
    ACCESS_TOKEN: 'accessToken',
    REFRESH_TOKEN: 'refreshToken',
    USER_CACHE: 'user',
    TRANSACTIONS: [
        'Investment',
        'Education',
        'Entertainment',
        'Food & Drinks',
        'Bill',
        'Groceries',
        'Health',
        'Dependants',
        'Transport',
        'Other',
      ],
    ACTIVITIES: [COMPLETED, FAILED, PENDING, PROCESSING]
}

export const TIME_FORMAT_OPTIONS = {
    DATE_MONTH_YEAR_OPTIONS: { 
        day: "numeric", 
        month: "short", 
        year: "numeric", 
    },
    TIME_OPTIONS: { 
        hour: "2-digit", 
        minute: "2-digit", 
        hour12: false, 
    },
    DATE_TIME_OPTIONS: { 
        day: "numeric", 
        month: "short", 
        year: "numeric", 
        hour: "2-digit", 
        minute: "2-digit", 
        hour12: false, 
        // timeZone: "UTC" // Add if you want UTC time
    },
    DATE_MONTH_OPTIONS: { 
        day: "numeric", 
        month: "short", 
    },
    DATE_OPTIONS: { 
        day: "numeric", 
    },
    MONTH_NAME_OPTIONS: { 
        month: "short",
    },
}

export const HTTP = {
    METHODS: {
        POST_METHOD: 'POST',
        GET_METHOD: 'GET',
        DELETE_METHOD: 'DELETE',
        PUT_METHOD: 'PUT',
        PATCH_METHOD: 'PATCH'
    },
    HEADERS: {
        CONTENT_TYPE: 'Content-Type',
        APPLICATION_JSON_CONTENT_TYPE:'application/json',
    }
}